module.exports = __webpack_public_path__ + "static/media/19ESCAP10.a5d229a3.jpg";